import { Injectable } from '@angular/core';
import { Pagina } from 'src/app/entidades/pagina';
import { Paginator } from 'src/app/entidades/paginator';
import { TipoEndosso } from 'src/app/entidades/tipoEndosso';
import { httpVerb } from 'src/app/enum/httpVerb';
import { ApiService } from '../api/api.service';
import { MensagemService } from '../mensagem/mensagem.service';

@Injectable({
  providedIn: 'root'
})
export class TipoEndossoService {

  constructor(private apiService: ApiService,
    private mensagemService: MensagemService) { }

  async AdicionarOuEditar(novoEndosso: TipoEndosso): Promise<TipoEndosso | undefined> {
    try {
      const result = await this.apiService.request<TipoEndosso>('/TipoEndosso', httpVerb.put, novoEndosso);
      if (result !== null && result !== undefined) {
        return result as TipoEndosso;
      }
      return undefined; // Retorna undefined se o resultado for nulo/indefinido
    } catch (error) {
      console.error('Erro ao adicionar ou editar TipoEndosso:', error);
      return undefined; // Retorna undefined em caso de erro
    }
  }

  async delete(id: number): Promise<boolean> {
    try {
      const result = await this.apiService.request<boolean>(`/TipoEndosso/${id}`, httpVerb.put);
      return this.apiService.verificaSeResult<boolean>(result);
    } catch (error) {
      console.error('Erro ao deletar TipoEndosso:', error);
      return false; // Retorna false em caso de erro
    }
  }

  async obter(paginator: Paginator): Promise<Pagina<TipoEndosso> | undefined> {
    try {
      const complemento = `/TipoEndosso?Pagina=${paginator.pageIndex + 1}&tamanhoPagina=${paginator.pageSize}`;
      const result = await this.apiService.request<Pagina<TipoEndosso>>(complemento, httpVerb.get);
      if (result !== null && result !== undefined) {
        return result as Pagina<TipoEndosso>;
      }
      return undefined; // Retorna undefined se o resultado for nulo/indefinido
    } catch (error) {
      console.error('Erro ao obter Tipos de Endosso:', error);
      this.mensagemService.showMessage('Erro ao obter Tipos de Endosso.', 'Ok', 5000, 'error');
      return undefined; // Retorna undefined em caso de erro
    }
  }

  async todos(): Promise<TipoEndosso[] | null> {
    try {
      const result = await this.apiService.request<TipoEndosso[]>('/tipoendosso/todos', httpVerb.get);
      if (result != null && result !== undefined) {
        return result;
      }
      return null; // Retorna null se o resultado for nulo/indefinido
    } catch (error) {
      console.error('Erro ao obter todos os Tipos de Endosso:', error);
      this.mensagemService.showMessage('Erro ao obter Tipos de Endosso.', 'Ok', 5000, 'error');
      return null; // Retorna null em caso de erro
    }
  }

  async obterTipoEndosso(id: number): Promise<TipoEndosso | undefined> {
    try {
      const result = await this.apiService.request<TipoEndosso>(`/tipoendosso/${id}`, httpVerb.get);
      if (result !== null && result !== undefined) {
        return result as TipoEndosso;
      }
      return undefined; // Retorna undefined se o resultado for nulo/indefinido
    } catch (error) {
      console.error('Erro ao obter Tipo de Endosso por ID:', error);
      this.mensagemService.showMessage('Erro ao alterar Tipo de Endosso.', 'Ok', 5000, 'error');
      return undefined; // Retorna undefined em caso de erro
    }
  }
}
